import { useEffect } from "react";
import { useAtom } from "jotai";
import moment from "moment";
import localeAtom from "@/atom/locale";

export const useLocale = () => {
    const [locale, setLocale] = useAtom(localeAtom);

    useEffect(() => {
        moment.locale(locale);
    }, [locale]);

    return { locale, setLocale };
};
